import { render } from "./ModalMiGente.vue?vue&type=template&id=e3207526&scoped=true&ts=true"
import script from "./ModalMiGente.vue?vue&type=script&lang=ts"
export * from "./ModalMiGente.vue?vue&type=script&lang=ts"

import "./ModalMiGente.vue?vue&type=style&index=0&id=e3207526&lang=scss&scoped=true"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3207526"]])

export default __exports__